// components/PrayerDisplay/CountdownOverlay.jsx
import React, { useEffect, useState } from "react";
import moment from "moment-timezone";

const CountdownOverlay = ({ nextEvent, remainingSeconds, timezone }) => {
  const [currentTime, setCurrentTime] = useState(moment.tz(moment(), timezone));
  const prayerName = nextEvent?.name || "PRAYER";

  useEffect(() => {
    //console.log("⏳ [CountdownOverlay] Active. Remaining:", remainingSeconds, "Next Event:", nextEvent?.name, "Event Time:",nextEvent?.time?.format("hh:mm:ss A"));
  }, [remainingSeconds, nextEvent]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment.tz(moment(), timezone));
    }, 1000);
    return () => clearInterval(interval);
  }, [timezone]);

  // Format time without leading zero
  const timePart = currentTime.format("h:mm");
  const meridiem = currentTime.format("A");

  return (
    <div className="fixed inset-0 z-50 bg-black flex flex-col items-center justify-center text-white">
      {/* Time Display (Top Left) */}
      <div className="absolute top-4 left-4 flex items-end space-x-1">
        <span className="text-[6svh] font-bold leading-none">{timePart}</span>
        <span className="text-[4svh] font-semibold leading-tight self-end">
          {meridiem}
        </span>
      </div>

      {/* Main Countdown Section */}
      <div className="flex flex-row items-center justify-center space-x-8 h-[14rem]">
        {/* Pulsing Countdown Number */}
        <div className="text-[14rem] font-extrabold leading-none">
          {remainingSeconds}
        </div>

        {/* Right-side Text Block (same vertical height alignment) */}
        <div className="flex flex-col justify-between h-full text-left leading-tight py-4">
          <span className="text-4xl font-light tracking-wider">
            SECONDS TO
          </span>
          <span className="text-5xl font-bold uppercase">
            {prayerName}
          </span>
          <span className="text-4xl font-semibold tracking-wider uppercase">
            IQAMAH
          </span>
        </div>
      </div>
    </div>
  );
};

export default CountdownOverlay;
